import React, { useEffect, useState, Fragment } from "react";
import { message } from 'antd';
import { ajax, unparam } from 'utils/common';
import mobileStatusIcon from "../../images/mobile_status_icon.png";
import "./index.less";

export default ({ }) => {
    const queryString = unparam(window.location.search);
    const [isMobile, setIsMobile] = useState(false); 
    let isRelease = location.href.includes('v.wintalent.cn') ? true : false;

    const isWechatOpen = () => {
        const ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            return true;
        } else {
            return false;
        }
    }

    const onOpenUrl = () => {
        let env_version = isRelease ? 'release' : 'trial';
        window.location.href = `${location.origin}/oivi/api/account/genQrCode/${queryString.type ? 'v1' : 'ai'}${location.search}&env_version=${env_version}`; 
    }
    
    useEffect(() => {
        document.title = queryString.type ? '大易云面' : 'AI面试';
        let userAgent = window.navigator.userAgent;
        if(userAgent.indexOf("Mobile") >= 0){
            if(isWechatOpen() && !isRelease){
                onOpenUrl();
                return;
            }
            setIsMobile(true);
            ajax({
                url: `/api/account/fetchUrlLink${queryString.type ? "" : "/ai"}`,
                data: {
                    ...queryString
                }
            }).then(res => {
                setIsMobile(false);
                let result = res.data || '';
                window.location.href=`${result}`
            }).catch(err => {
                message.error("获取链接失败！")
                setIsMobile(false);
            })
        } else {
            onOpenUrl();
        }
    }, [])

    return (
        <div className="mobile_tips_wrap">
            {
                isMobile ? (
                    <Fragment>
                        <div className="box-title">你好，正在进入{queryString.type ? '视频面试' : 'AI面试'}...</div>
                        <div className="box-bg"></div>
                        <div class="loading">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </Fragment>
                ) : (
                    <Fragment>
                        {/* <img className="mobile_tips_icon" src={mobileStatusIcon} />
                        <div className="mobile_tips_title">请使用微信扫码</div>    */}
                    </Fragment>
                )
            }
        </div>
    )
}